import { atom } from "jotai";
import activeWindowAtom from "app/uiState/activeWindowAtom";
import uniqueId from "lodash/uniqueId";
import openedWindowIdsAtom from "app/uiState/openedWindowIdsAtom";
import getWindowAtom from "app/uiState/getWindowAtom";
import {
  ComponentName,
  ComponentProps,
  ComponentState,
  UIProps,
  componentOptions,
} from "app/componentOptions";

const openWindowAtom = atom(
  null,
  (
    get,
    set,
    {
      componentType,
      componentProps,
      uiProps = {},
      componentId,
    }: ComponentState<ComponentName>,
    { background = false }: { background?: boolean } = {},
  ) => {
    set(openedWindowIdsAtom, (ids: string[]) => [...ids, componentId]);

    set(getWindowAtom(componentId), {
      componentId,
      componentType,
      componentProps,
      uiProps: {
        ...componentOptions[componentType].defaultUiOptions,
        ...uiProps,
        ...(background ? { zIndex: 0 } : {}),
      },
    });

    if (!background) set(activeWindowAtom, componentId);
  },
);

export default openWindowAtom;
